import SessionEventProto from "../session-event-proto";


export default class EventCustomFieldsReset extends SessionEventProto {

    process() {
        gd.session.customFields.resetAndMarkOldModelsAsDeleted(this.data)

    }
}




// const EventCustomFieldsReset = function(uid,data) {
//     this.data = data;
//     this.uid = uid;
// };
//
// EventCustomFieldsReset.prototype.validate = function(){
//     return true;
// };
//
// EventCustomFieldsReset.prototype.process = function(){
//     gd.session.customFields.resetAndMarkOldModelsAsDeleted(this.data)
// }
//
//
// module.exports = EventCustomFieldsReset;
